module.exports = __webpack_public_path__ + "minisvijet.c05a8294c9d0e0254d60.jpg";